import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UserAccessState {
  isAdmin: boolean
}

const initialState: UserAccessState = {
  isAdmin: false
}

const userAccessSlice = createSlice({
  name: 'userAccess',
  initialState,
  reducers: {
    setIsAdmin: (state, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload
    }
  }
})

export const { setIsAdmin } = userAccessSlice.actions
export const userAdminReducer = userAccessSlice.reducer
